import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation, Link } from 'react-router-dom';

import { formatNull } from '../../Utils/GlobalUtils';
import { useTimeModal } from '../TimeModal/TimeModalContext';

import LoadingLines from '../LoadingLines';
import WarningPanel from '../WarningPanel';

import AddNewDebtorToCase from './AddNewDebtorToCase';

import styles from '../../styles/MiniTables.module.css';

import ButtonWithConfirmation from '../ButtonWithConfirmation';
import { ReactComponent as MinusCircleIcon } from '../../icons/minus-circle.svg';
import IconContainer from '../../Components/IconContainer';
import { ReactComponent as XIcon } from '../../icons/pen.svg';

export default function CaseDebtors({ caseId, debtors_ids, isShowNullTable=true, reload, onSuccess, formInfo, setFormInfo, access=false, isShowButtons=false }) {
    const navigate = useNavigate();
    const location = useLocation();

    const { openTimeModal } = useTimeModal();

    const [entries, setEntries] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (!debtors_ids || debtors_ids.length === 0) {
        if (isShowNullTable) setWarning('Должники не прикреплены');
        setEntries([]);
        setLoading(false);
        return;
        }
        
        axios.get(`/api/get-case-debtors`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                debtors_ids: debtors_ids.join(','),
            }
        })
        .then((response) => {
        if (response.data.length === 0) {
            if (isShowNullTable) {
                setWarning('Должники не прикреплены');
            } else {
                setWarning('');
            }
            setEntries([]);
        } else {
            setWarning(``);
            setEntries(response.data);
        }
        })
        .catch((error) => {
            console.log(error)
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            setEntries([]);
        })
        .finally(() => {
            setLoading(false);
        })
    }, [reload, debtors_ids.join(',')]);

    const deleteCaseDebtor = (debtorId, caseId) => {
        const token = localStorage.getItem('token');

        axios.delete(`/api/delete-case-debtor?debtor_id=${debtorId}&case_id=${caseId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            openTimeModal('Должник успешно откреплен', 'success');
            onSuccess();
        })
        .catch((error) => {
            openTimeModal(`${error.response?.data.message || 'Ошибка при открепления должника от дела'}`, 'error');
        })
        .finally(() => {
            onSuccess();
        });
    };

    return (
        <>
        {isShowButtons &&
        <AddNewDebtorToCase 
            caseId={caseId} 
            formInfo={formInfo} 
            setFormInfo={setFormInfo} 
            onSuccess={onSuccess} 
        />}

        {loading ? <LoadingLines />
        : warning ? <WarningPanel text={warning} />
        : entries.length > 0 && 
        <div className={styles.table}>
            {entries.map((entry) => (
                <div 
                    className={styles.line}
                    key={entry.id} 
                    style={{ gridTemplateColumns: '50fr 49fr 1fr 1fr' }}
                >
                    <div>
                        <div>
                            <Link 
                                className='aWithLink'
                                to={`/debtor/${entry.id}`}
                            >
                                {entry.name}
                            </Link>
                        </div>
                    </div>
                    <div>
                        {formatNull(entry.postal_address)}
                    </div>
                    {isShowButtons &&
                    <>
                    <div>
                        <IconContainer 
                            Icon={XIcon} 
                            label='Изменить данные'
                            onClick={() => {
                                navigate(`/change-debtor/${entry.id}`, { state: { from: location.pathname + location.search + location.hash }})
                            }} 
                            size = '16' 
                            color = 'black' 
                            className = '' 
                        />
                    </div>
                    <div>
                        <ButtonWithConfirmation 
                            entryFunc={() => {deleteCaseDebtor(entry.id, caseId)}} 
                            Icon={MinusCircleIcon} 
                            IconSize={16}
                            labelText='Открепить должника' 
                            buttonName='Открепить должника' 
                            color='black' 
                        />
                    </div>
                    </>}
                </div>
            ))}
        </div>}
        </>
    )
}
